<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        Disable Accounts
    </ng-container>

    <ng-container dialog-process-in-progress>
        <div class="my-3 pl-3">
            <app-checkbox [(ngModel)]="selectAll" (ngModelChange)="selectAllAccounts($event)">
                <ng-container text>Select all</ng-container>
            </app-checkbox>
        </div>

        <app-report-table
            [config]="dataTableConfig"
        ></app-report-table>

        <div *ngIf='disableAccountsForm && disableAccountsForm.errors.length > 0' class="form-text text-danger pl-3">
            <span *ngFor="let error of disableAccountsForm.errors">{{error}}</span>
        </div>
    </ng-container>
</app-dialog>
